/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} In_ProgressInputs */



/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const in_progress = /** @type {((inputs?: In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Gange")
	if (locale === "it") return /** @type {LocalizedString} */ ("In corso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В ходе выполнения")
	if (locale === "es") return /** @type {LocalizedString} */ ("En curso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进行中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("進行中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रगति पर है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Em andamento")
	return /** @type {LocalizedString} */ ("In Progress")
});